"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBasketToClaimSaga = addBasketToClaimSaga;
exports.copyBasketToBufferSaga = copyBasketToBufferSaga;
exports.copyBasketURLToBufferSaga = copyBasketURLToBufferSaga;
exports.createBasketSaga = createBasketSaga;
exports.default = basketsRootSaga;
exports.fetchBasketsSimplified = fetchBasketsSimplified;
exports.getBasketsSaga = getBasketsSaga;
exports.getBasketsSimplifiedSaga = getBasketsSimplifiedSaga;
exports.getManagersSaga = getManagersSaga;
exports.moveOfferInBasketSaga = moveOfferInBasketSaga;
exports.removeBasketSaga = removeBasketSaga;
exports.saveBasketsSaga = saveBasketsSaga;
exports.setBasketTemplatesSaga = setBasketTemplatesSaga;
exports.setOffersReviewsLinksSaga = setOffersReviewsLinksSaga;
exports.updateBasketSaga = updateBasketSaga;
exports.updateBasketStatusSaga = updateBasketStatusSaga;
exports.updateOfferInBasketSaga = updateOfferInBasketSaga;
var _effects = require("redux-saga/effects");
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("@otpusk/apisearch-toolbox/dist/offers/actions");
var _constants = require("@otpusk/apisearch-toolbox/dist/offers/constants");
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _actions2 = require("@otpusk/apisearch-toolbox/dist/hotels/actions");
var _helpers = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _fn = require("../../../helpers/fn");
var _api = require("../../../helpers/api");
var _config = require("../../../services/config");
var _ConfirmModal = require("../../ConfirmModal");
var _saga = _interopRequireDefault(require("../components/SearchForm/store/saga"));
var _saga2 = require("../components/Results/components/Offer/store/saga");
var _saga3 = _interopRequireDefault(require("../components/Results/components/EditForm/components/SendBasketModal/store/saga"));
var _saga4 = _interopRequireDefault(require("../components/Results/components/EditForm/store/saga"));
var _BasketCounter = require("../components/BasketCounter");
var _actions3 = require("../../../bus/ui/actions");
var _localization = _interopRequireDefault(require("../../../localization"));
var _actions4 = require("./actions");
var _helpers2 = require("./helpers");
var _selectors2 = require("./selectors");
var _constants2 = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(saveBasketsSaga),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(createBasketSaga),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(getManagersSaga),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(setOffersReviewsLinksSaga),
  _marked5 = /*#__PURE__*/_regeneratorRuntime().mark(setBasketTemplatesSaga),
  _marked6 = /*#__PURE__*/_regeneratorRuntime().mark(basketsRootSaga);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function saveBasketsSaga(baskets) {
  var basketsIDs, basketsMap, offers, hotels;
  return _regeneratorRuntime().wrap(function saveBasketsSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        basketsIDs = R.map(R.prop('id'), baskets);
        basketsMap = R.call(R.pipe(R.map(_helpers2.basketNormalizer), R.indexBy(R.prop('id'))), baskets);
        _context.next = 4;
        return (0, _effects.all)([(0, _effects.put)((0, _actions4.setBaskets)(basketsMap)), (0, _effects.put)((0, _actions4.setBasketsOrderIDs)(basketsIDs))]);
      case 4:
        offers = (0, _helpers2.getOffers)(baskets);
        hotels = (0, _helpers2.getHotelsIDs)(baskets);
        _context.next = 8;
        return (0, _effects.all)([].concat(_toConsumableArray(R.map(function (hotelID) {
          return (0, _effects.put)(_actions2.hotelsActions.getHotel(hotelID));
        }, hotels)), _toConsumableArray(R.map(function (offer) {
          return (0, _effects.all)([(0, _effects.put)(_actions.offersActions.setOffer(offer.id, offer)), (0, _effects.put)(_actions.offersActions.setOfferStatus(offer.id, _constants.UNKNOWN_OFFER_STATUS))]);
        }, offers)), _toConsumableArray(R.map(function (hotelID) {
          return (0, _effects.race)([(0, _effects.take)(function (action) {
            return R.and(R.equals(action.type, _actions2.hotelsActions.getHotelSuccess.toString()), R.equals(R.prop('id', action.payload), String(hotelID)));
          }), (0, _effects.take)(function (action) {
            return R.equals(action.type, _actions2.hotelsActions.getHotelFail.toString());
          })]);
        }, hotels))));
      case 8:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
function getBasketsSaga(_ref) {
  var params = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var callback, _yield$call, baskets, perPage, total, page;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          callback = (0, _config.getOnGetBaskets)();
          if (!callback) {
            _context2.next = 13;
            break;
          }
          _context2.next = 4;
          return (0, _effects.call)(callback, params);
        case 4:
          _yield$call = _context2.sent;
          baskets = _yield$call.baskets;
          perPage = _yield$call.perPage;
          total = _yield$call.total;
          page = _yield$call.page;
          _context2.next = 11;
          return (0, _effects.put)((0, _actions4.setPagination)({
            total: total,
            perPage: perPage,
            initialPage: page
          }));
        case 11:
          _context2.next = 13;
          return (0, _effects.call)(saveBasketsSaga, baskets);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  })();
}
function fetchBasketsSimplified() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants2.BASKET_STATUSES_MAP.ALL;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var callback, _yield$call2, baskets, perPage, total;
    return _regeneratorRuntime().wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          callback = (0, _config.getOnGetBasketsSimplified)();
          if (!callback) {
            _context3.next = 11;
            break;
          }
          _context3.next = 4;
          return (0, _effects.call)(callback, {
            page: page,
            limit: limit,
            status: status
          });
        case 4:
          _yield$call2 = _context3.sent;
          baskets = _yield$call2.baskets;
          perPage = _yield$call2.perPage;
          total = _yield$call2.total;
          _context3.next = 10;
          return (0, _effects.put)((0, _actions4.setBasketsSimplifiedPagination)({
            total: total,
            perPage: perPage
          }));
        case 10:
          return _context3.abrupt("return", R.map(_helpers2.basketsSimplifiedNormalizer, baskets));
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee2);
  })();
}
function getBasketsSimplifiedSaga(_ref2) {
  var _ref2$payload = _ref2.payload,
    page = _ref2$payload.page,
    limit = _ref2$payload.limit,
    status = _ref2$payload.status;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var basket;
    return _regeneratorRuntime().wrap(function _callee3$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.call)(fetchBasketsSimplified, page, limit, status);
        case 2:
          basket = _context4.sent;
          if (!basket) {
            _context4.next = 6;
            break;
          }
          _context4.next = 6;
          return (0, _effects.put)((0, _actions4.setBasketsSimplified)(basket));
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee3);
  })();
}
function createBasketSaga() {
  var callback, basket, normalizedBasket;
  return _regeneratorRuntime().wrap(function createBasketSaga$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        callback = (0, _config.getOnCreateBasket)();
        if (!callback) {
          _context5.next = 9;
          break;
        }
        _context5.next = 4;
        return (0, _effects.call)(callback);
      case 4:
        basket = _context5.sent;
        normalizedBasket = (0, _helpers2.basketNormalizer)(basket);
        _context5.next = 8;
        return (0, _effects.put)((0, _actions4.addBasket)(normalizedBasket));
      case 8:
        return _context5.abrupt("return", normalizedBasket);
      case 9:
      case "end":
        return _context5.stop();
    }
  }, _marked2);
}
function addBasketToClaimSaga(_ref3) {
  var _ref3$payload = _ref3.payload,
    basketID = _ref3$payload.basketID,
    claimID = _ref3$payload.claimID,
    clientID = _ref3$payload.clientID,
    callbacks = _ref3$payload.callbacks;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var transport, onStart, onSuccess, onFinish, onFail, onCloseModal, claim;
    return _regeneratorRuntime().wrap(function _callee4$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          transport = (0, _config.getOnAddBasketToClaim)();
          if (!transport) {
            _context6.next = 20;
            break;
          }
          onStart = callbacks.onStart, onSuccess = callbacks.onSuccess, onFinish = callbacks.onFinish, onFail = callbacks.onFail, onCloseModal = callbacks.onCloseModal;
          if (onStart) {
            onStart();
          }
          _context6.prev = 4;
          _context6.next = 7;
          return (0, _effects.call)(transport, basketID, claimID, clientID);
        case 7:
          claim = _context6.sent;
          if (onSuccess) {
            onSuccess();
          }
          if (onCloseModal) {
            onCloseModal();
          }
          _context6.next = 12;
          return (0, _effects.put)((0, _actions4.setClaimToBasket)(basketID, claim));
        case 12:
          _context6.next = 17;
          break;
        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](4);
          if (onFail) {
            onFail(_context6.t0);
          }
        case 17:
          _context6.prev = 17;
          onFinish();
          return _context6.finish(17);
        case 20:
        case "end":
          return _context6.stop();
      }
    }, _callee4, null, [[4, 14, 17, 20]]);
  })();
}
function removeBasketSaga(_ref4) {
  var basketID = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var callback;
    return _regeneratorRuntime().wrap(function _callee5$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          callback = (0, _config.getOnRemoveBasket)();
          if (!callback) {
            _context7.next = 6;
            break;
          }
          _context7.next = 4;
          return (0, _effects.call)(callback, basketID);
        case 4:
          _context7.next = 6;
          return (0, _effects.put)((0, _actions4.removeBasket)(basketID));
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee5);
  })();
}
function updateBasketSaga(_ref5) {
  var _ref5$payload = _ref5.payload,
    basketID = _ref5$payload.basketID,
    basket = _ref5$payload.basket;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var callback, nextBasket, normalizedBasket;
    return _regeneratorRuntime().wrap(function _callee6$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          callback = (0, _config.getOnUpdateBasket)();
          if (!callback) {
            _context8.next = 8;
            break;
          }
          _context8.next = 4;
          return (0, _effects.call)(callback, basketID, basket);
        case 4:
          nextBasket = _context8.sent;
          normalizedBasket = (0, _helpers2.basketNormalizer)(nextBasket);
          _context8.next = 8;
          return (0, _effects.put)((0, _actions4.setBasket)(normalizedBasket));
        case 8:
        case "end":
          return _context8.stop();
      }
    }, _callee6);
  })();
}
function updateBasketStatusSaga(_ref6) {
  var _ref6$payload = _ref6.payload,
    basketID = _ref6$payload.basketID,
    status = _ref6$payload.status;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var callback;
    return _regeneratorRuntime().wrap(function _callee7$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          callback = (0, _config.getOnUpdateBasketStatus)();
          if (!callback) {
            _context9.next = 6;
            break;
          }
          _context9.next = 4;
          return (0, _effects.call)(callback, basketID, {
            status: status
          });
        case 4:
          _context9.next = 6;
          return (0, _effects.put)((0, _actions4.removeBasket)(basketID));
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee7);
  })();
}
function updateOfferInBasketSaga(_ref7) {
  var _ref7$payload = _ref7.payload,
    offerID = _ref7$payload.offerID,
    basketID = _ref7$payload.basketID,
    offer = _ref7$payload.offer;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var callback, _yield$select, id, basket, normalizedBasket;
    return _regeneratorRuntime().wrap(function _callee8$(_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          callback = (0, _config.getOnUpdateOfferInBasket)();
          if (!callback) {
            _context0.next = 12;
            break;
          }
          _context0.next = 4;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOfferExtra)(state, {
              basketID: basketID,
              offerID: offerID
            });
          });
        case 4:
          _yield$select = _context0.sent;
          id = _yield$select.id;
          _context0.next = 8;
          return (0, _effects.call)(callback, basketID, id, offer);
        case 8:
          basket = _context0.sent;
          normalizedBasket = (0, _helpers2.basketNormalizer)(basket);
          _context0.next = 12;
          return (0, _effects.put)((0, _actions4.setBasket)(normalizedBasket));
        case 12:
        case "end":
          return _context0.stop();
      }
    }, _callee8);
  })();
}
function moveOfferInBasketSaga(_ref8) {
  var _ref8$payload = _ref8.payload,
    offerKey = _ref8$payload.offerKey,
    nextIndexPosition = _ref8$payload.nextIndexPosition;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _extractDataFromOffer, basketID, currentIndexPosition, callback, _yield$select2, id;
    return _regeneratorRuntime().wrap(function _callee9$(_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          _extractDataFromOffer = (0, _helpers.extractDataFromOfferKey)(offerKey), basketID = _extractDataFromOffer.meta.basketID;
          _context1.next = 3;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOfferPositionInBasket)(state, {
              basketID: basketID,
              offerID: offerKey
            });
          });
        case 3:
          currentIndexPosition = _context1.sent;
          _context1.next = 6;
          return (0, _effects.put)((0, _actions4.updateOffersPositionInBasket)(basketID, nextIndexPosition, currentIndexPosition));
        case 6:
          _context1.prev = 6;
          callback = (0, _config.getOnMoveOfferInBasket)();
          if (!callback) {
            _context1.next = 15;
            break;
          }
          _context1.next = 11;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOfferExtra)(state, {
              basketID: basketID,
              offerID: offerKey
            });
          });
        case 11:
          _yield$select2 = _context1.sent;
          id = _yield$select2.id;
          _context1.next = 15;
          return (0, _effects.call)(callback, basketID, id, nextIndexPosition);
        case 15:
          _context1.next = 21;
          break;
        case 17:
          _context1.prev = 17;
          _context1.t0 = _context1["catch"](6);
          _context1.next = 21;
          return (0, _effects.put)((0, _actions4.updateOffersPositionInBasket)(basketID, currentIndexPosition, nextIndexPosition));
        case 21:
        case "end":
          return _context1.stop();
      }
    }, _callee9, null, [[6, 17]]);
  })();
}
function removeOfferFromBasketSaga(_ref9) {
  var _ref9$payload = _ref9.payload,
    offerID = _ref9$payload.offerID,
    basketID = _ref9$payload.basketID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee0() {
    var callback, _yield$select3, id, offer;
    return _regeneratorRuntime().wrap(function _callee0$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          callback = (0, _config.getOnRemoveOfferFromBasket)();
          _context10.next = 3;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOfferExtra)(state, {
              basketID: basketID,
              offerID: offerID
            });
          });
        case 3:
          _yield$select3 = _context10.sent;
          id = _yield$select3.id;
          _context10.next = 7;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 7:
          offer = _context10.sent;
          if (!callback) {
            _context10.next = 13;
            break;
          }
          _context10.next = 11;
          return (0, _effects.call)(callback, id, basketID, offer);
        case 11:
          _context10.next = 13;
          return (0, _effects.put)((0, _actions4.removeOfferFromBasket)(offerID, basketID));
        case 13:
        case "end":
          return _context10.stop();
      }
    }, _callee0);
  })();
}
function removeClaimFromBasketSaga(_ref0) {
  var _ref0$payload = _ref0.payload,
    claimID = _ref0$payload.claimID,
    basketID = _ref0$payload.basketID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee1() {
    var callback, errorMsg;
    return _regeneratorRuntime().wrap(function _callee1$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          callback = (0, _config.getOnRemoveClaimFromBasket)();
          if (!callback) {
            _context11.next = 22;
            break;
          }
          _context11.prev = 2;
          _context11.next = 5;
          return (0, _effects.put)((0, _actions3.register)(_constants2.REMOVE_CLAIM_FROM_BASKET_UI, {
            loading: true
          }));
        case 5:
          _context11.next = 7;
          return (0, _effects.call)(callback, basketID, claimID);
        case 7:
          _context11.next = 9;
          return (0, _effects.put)((0, _actions4.removeClaimFromBasket)(basketID));
        case 9:
          _context11.next = 18;
          break;
        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](2);
          _context11.next = 15;
          return (0, _effects.call)(_api.getErrorMessage, _context11.t0);
        case 15:
          errorMsg = _context11.sent;
          _context11.next = 18;
          return (0, _effects.put)((0, _actions3.update)(_constants2.REMOVE_CLAIM_FROM_BASKET_UI, {
            error: true,
            message: errorMsg
          }));
        case 18:
          _context11.prev = 18;
          _context11.next = 21;
          return (0, _effects.put)((0, _actions3.update)(_constants2.REMOVE_CLAIM_FROM_BASKET_UI, {
            loading: false,
            completed: true
          }));
        case 21:
          return _context11.finish(18);
        case 22:
        case "end":
          return _context11.stop();
      }
    }, _callee1, null, [[2, 11, 18, 22]]);
  })();
}
function getManagersSaga() {
  var callback, managers;
  return _regeneratorRuntime().wrap(function getManagersSaga$(_context12) {
    while (1) switch (_context12.prev = _context12.next) {
      case 0:
        callback = (0, _config.getOnGetManagers)();
        if (!callback) {
          _context12.next = 13;
          break;
        }
        _context12.prev = 2;
        _context12.next = 5;
        return (0, _effects.call)(callback);
      case 5:
        managers = _context12.sent;
        _context12.next = 8;
        return (0, _effects.put)((0, _actions4.setManagers)(managers));
      case 8:
        _context12.next = 13;
        break;
      case 10:
        _context12.prev = 10;
        _context12.t0 = _context12["catch"](2);
        console.log(_context12.t0);
      case 13:
      case "end":
        return _context12.stop();
    }
  }, _marked3, null, [[2, 10]]);
}
function setOffersReviewsLinksSaga() {
  var callback, links;
  return _regeneratorRuntime().wrap(function setOffersReviewsLinksSaga$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        callback = (0, _config.getOnGetOffersReviewsLinks)();
        if (!callback) {
          _context13.next = 13;
          break;
        }
        _context13.prev = 2;
        _context13.next = 5;
        return (0, _effects.call)(callback);
      case 5:
        links = _context13.sent;
        _context13.next = 8;
        return (0, _effects.put)((0, _actions4.setOffersReviewsLinks)(links));
      case 8:
        _context13.next = 13;
        break;
      case 10:
        _context13.prev = 10;
        _context13.t0 = _context13["catch"](2);
        console.log(_context13.t0);
      case 13:
      case "end":
        return _context13.stop();
    }
  }, _marked4, null, [[2, 10]]);
}
function setBasketTemplatesSaga() {
  var callback, templates;
  return _regeneratorRuntime().wrap(function setBasketTemplatesSaga$(_context14) {
    while (1) switch (_context14.prev = _context14.next) {
      case 0:
        callback = (0, _config.getOnGetBasketTemplates)();
        if (!callback) {
          _context14.next = 13;
          break;
        }
        _context14.prev = 2;
        _context14.next = 5;
        return (0, _effects.call)(callback);
      case 5:
        templates = _context14.sent;
        _context14.next = 8;
        return (0, _effects.put)((0, _actions4.setBasketTemplates)(templates));
      case 8:
        _context14.next = 13;
        break;
      case 10:
        _context14.prev = 10;
        _context14.t0 = _context14["catch"](2);
        console.log(_context14.t0);
      case 13:
      case "end":
        return _context14.stop();
    }
  }, _marked5, null, [[2, 10]]);
}
function copyBasketToBufferSaga(_ref1) {
  var basketID = _ref1.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var callback, basket;
    return _regeneratorRuntime().wrap(function _callee10$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          callback = (0, _config.getOnGetBasketTemplate)();
          _context15.next = 3;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getBasketById)(state, {
              basketID: basketID
            });
          });
        case 3:
          basket = _context15.sent;
          if (!callback) {
            _context15.next = 22;
            break;
          }
          _context15.next = 7;
          return (0, _effects.put)((0, _actions3.setIsVisibleGlobalLoader)(true));
        case 7:
          _context15.prev = 7;
          _context15.next = 10;
          return (0, _effects.call)(_fn.copyToBufferDynamicContent, function () {
            return callback(basket);
          });
        case 10:
          _context15.next = 12;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            header: _localization.default.t('BASKET_EDIT_FORM:SUCCESS_COPY_BASKET_TO_BUFFER_MODAL_HEADER'),
            content: _localization.default.t('BASKET_EDIT_FORM:SUCCESS_COPY_BASKET_TO_BUFFER_MODAL_DESCRIPTION'),
            cancelButton: false,
            confirmButtonText: _localization.default.t('CONFIRM_MODAL:OK')
          }));
        case 12:
          _context15.next = 18;
          break;
        case 14:
          _context15.prev = 14;
          _context15.t0 = _context15["catch"](7);
          _context15.next = 18;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            content: _localization.default.t('API_REQUESTS_ERRORS:ERROR_SERVER'),
            cancelButton: false
          }));
        case 18:
          _context15.prev = 18;
          _context15.next = 21;
          return (0, _effects.put)((0, _actions3.setIsVisibleGlobalLoader)(false));
        case 21:
          return _context15.finish(18);
        case 22:
        case "end":
          return _context15.stop();
      }
    }, _callee10, null, [[7, 14, 18, 22]]);
  })();
}
function copyBasketURLToBufferSaga(_ref10) {
  var copyContent = _ref10.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          (0, _fn.copyToBuffer)(copyContent);
          _context16.next = 4;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            header: _localization.default.t('BASKET_EDIT_FORM:SUCCESS_COPY_BASKET_LINK_TO_BUFFER_MODAL_HEADER'),
            content: _localization.default.t('BASKET_EDIT_FORM:SUCCESS_COPY_BASKET_LINK_TO_BUFFER_MODAL_DESCRIPTION'),
            cancelButton: false
          }));
        case 4:
          _context16.next = 10;
          break;
        case 6:
          _context16.prev = 6;
          _context16.t0 = _context16["catch"](0);
          _context16.next = 10;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            content: _localization.default.t('API_REQUESTS_ERRORS:ERROR_SERVER'),
            cancelButton: false
          }));
        case 10:
        case "end":
          return _context16.stop();
      }
    }, _callee11, null, [[0, 6]]);
  })();
}
function basketsRootSaga() {
  return _regeneratorRuntime().wrap(function basketsRootSaga$(_context18) {
    while (1) switch (_context18.prev = _context18.next) {
      case 0:
        _context18.next = 2;
        return (0, _effects.all)([(0, _effects.takeEvery)(_actions4.getBaskets, getBasketsSaga), (0, _effects.takeEvery)(_actions4.getBasketsSimplified, getBasketsSimplifiedSaga), (0, _effects.takeEvery)(_actions4.startRemovingBasket, removeBasketSaga), (0, _effects.takeEvery)(_actions4.updateOfferInBasket, updateOfferInBasketSaga), (0, _effects.takeEvery)(_actions4.moveOfferInBasket, moveOfferInBasketSaga), (0, _effects.takeEvery)(_actions4.startRemoveOfferFromBasket, removeOfferFromBasketSaga), (0, _effects.takeEvery)(_actions4.startRemoveClaimFromBasket, removeClaimFromBasketSaga), (0, _effects.takeEvery)(_actions4.updateBasket, updateBasketSaga), (0, _effects.takeEvery)(_actions4.addBasketToClaim, addBasketToClaimSaga), (0, _effects.takeEvery)(_actions4.copyBasketToBuffer, copyBasketToBufferSaga), (0, _effects.takeEvery)(_actions4.copyBasketUrlToBuffer, copyBasketURLToBufferSaga), (0, _effects.takeEvery)([_actions4.archiveBasket, _actions4.unArchiveBasket], function proxySaga(_ref11) {
          var basketID = _ref11.payload,
            type = _ref11.type;
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
            var status;
            return _regeneratorRuntime().wrap(function _callee12$(_context17) {
              while (1) switch (_context17.prev = _context17.next) {
                case 0:
                  status = type === _actions4.archiveBasket.toString() ? _constants2.BASKET_STATUSES_MAP.ARCHIVE : _constants2.BASKET_STATUSES_MAP.ALL;
                  _context17.next = 3;
                  return (0, _effects.put)((0, _actions4.updateBasketStatus)(basketID, status));
                case 3:
                case "end":
                  return _context17.stop();
              }
            }, _callee12);
          })();
        }), (0, _effects.takeEvery)(_actions4.updateBasketStatus, updateBasketStatusSaga), (0, _saga.default)(), (0, _saga3.default)(), (0, _saga4.default)(), (0, _saga2.basketOfferRootSaga)(), (0, _BasketCounter.basketCounterRootSaga)()]);
      case 2:
      case "end":
        return _context18.stop();
    }
  }, _marked6);
}